let rolesApi = {
  async get(token, companyId, params = {}) {
    let response = await window.axios.get("/api/roles", {
      params: {
        api_token: token,
        company_logged: companyId,
        ...params,
      },
    });
    return response.data;
  },
};

export default rolesApi;
